var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.137 0.004 23.808 23.935",
    width: 23.808,
    height: 23.935,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "event",
    clipRule: "event",
    d: "M 23.945 2.225 C 23.945 0.965 22.966 0.004 21.831 0.004 L 9.149 0.004 C 8.013 0.004 7.035 0.965 7.035 2.225 L 7.035 5.535 L 15.742 5.535 C 17.023 5.535 18.126 6.764 18.126 8.376 L 18.126 14.258 L 21.831 14.258 C 22.966 14.258 23.945 13.297 23.945 12.036 L 23.945 2.225 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "event",
    clipRule: "event",
    d: "M 2.25 6.657 C 1.115 6.657 0.137 7.618 0.137 8.878 L 0.137 18.688 C 0.137 19.949 1.115 20.91 2.25 20.91 L 13 20.91 L 15.607 23.677 C 15.85 23.935 16.212 24.01 16.527 23.869 C 16.842 23.727 17.047 23.396 17.047 23.03 L 17.047 8.878 C 17.047 7.618 16.069 6.657 14.933 6.657 L 2.25 6.657 Z",
    style: {}
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.525ea124f1fb1d9202422f907460a6cf.svg";
export { ForwardRef as ReactComponent };